export default [
  {
    path: '/algoritmos/regras',
    name: 'algorithm-rules-index',
    component: () => import('./pages/RulesIndex'),
    meta: {
      title: 'Regras dos algoritmos',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: [
        { text: 'Algoritmos', disabled: true, href: '/' },
        { text: 'Regras', disabled: true, href: '/' },
      ],
    },
  },
]
